import { render, staticRenderFns } from "./carencias.vue?vue&type=template&id=7d64162b&scoped=true"
import script from "./carencias.vue?vue&type=script&lang=js"
export * from "./carencias.vue?vue&type=script&lang=js"
import style0 from "./carencias.vue?vue&type=style&index=0&id=7d64162b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64162b",
  null
  
)

export default component.exports